(function () {
    'use strict';

    angular
        .module('cog.shared.customer')
        .controller('SelStep1Controller', SelStep1Controller);

    /* @ngInject */
    function SelStep1Controller(tp, $state, customerGameSelection: ICustomerSelection, $mdDialog, $location, $timeout,
        notificationService: INotificationService, cogApiService: IApiService, betModelTransformer: IBetTranformer, accountService, BET_TYPES, $mdToast, $rootScope, appSettings, $scope, CogApiServiceProvider: ICogApiServiceProvider, lineFormater: ILineFormater, $window) {
        var _tp = accountService.getBetSelectionType();
        var is_bm: boolean = CogApiServiceProvider.is_BM();
        var vm = this;
        var local = { DelayUntilSignature:"", DelayUntilUTC: null, WaitHandler: null };
        vm.nextStep = nextStep;
        vm.selectedIndex = 0;
        vm.selCount = 0;
        vm.cancelAll = cancelAll;
        vm.cancel = cancel;
        vm.betTypeLbl = accountService.getBetSelectionDesc();
        vm.acceptLine = acceptLine;
        vm.changeAmount = changeAmount;
        vm.hasError = false;
        vm.apiError = false;
        vm.noWagerBet = false;
        vm.isStraight = (_tp == BET_TYPES.S.type || _tp == BET_TYPES.E.type) ? true : false;
        vm.isIfbet = (_tp == BET_TYPES.I.type) ? true : false;
        vm.isActionReverse = (_tp == BET_TYPES.A.type) ? true : false;
        vm.isPropfecta = (_tp == BET_TYPES.B.type) ? true : false;
        vm.showItemRiskWin = showItemRiskWin();
        vm.betAmount = (_tp == BET_TYPES.S.type || _tp == BET_TYPES.E.type) ? 0 : customerGameSelection.gameSelections.GetBetAmount();
        vm.sel = {};
        vm.selected = [];
        vm.rr = [];
        vm.pd = [];
        vm.currency = appSettings.currency;
        vm.currencyDecimals = appSettings.currencyDecimals;
        vm.loader = true;
        vm.winpush = 1; // win = 0, win push = 1
        vm.setWinPush = setWinPush;
        vm.betNumLbl = betNumLbl;
        vm.chgAmtRR = chgAmtRR;
        vm.cancelRR = cancelRR;
        vm.removeOpenSpot = removeOpenSpot;
        vm.FreePlayBalance = customerGameSelection.customerAvailableOptions.FreePlayAmount;
        vm.useFreePlay = customerGameSelection.gameSelections.GetFreePlay();
        vm.EnabledFreePlay = false;
        vm.isBM = CogApiServiceProvider.is_BM();
        vm.editDetails = editDetails;
        var lineDataEdited: boolean = false;
        vm.ticketNumLbl = ticketNumLbl;
        vm.allowEdit = accountService.getAllowEdit();
        vm.cancelMain = cancelMain;
        vm.allowOverRide = false;
        vm.overrideRules = overrideRules;
        vm.showFinalRR = false;
        vm.totalRR = totalRR;
        vm.gotoPending = gotoPending;
        vm.getFormatLine = getFormatLine;
        vm.captcha = { CaptchaImage: null, CaptchaMessage: "", Error: false, Description: "" };
        vm.confirmation = { NeedConfirmation: false, Password: "", Error: false, Description: "" };
        vm.onInputEnter = onInputEnter;

        // for selstep1cust
        vm.selectAllContent = selectAllContent;
        vm.placeBetAmount = placeBetAmount;
        vm.getFormat = betModelTransformer.getLineFormat;
        vm.onBuyPointsChange = onBuyPointsChange;
        vm.betError = [];
        // for openSpots
        vm.allowOpenSpotOption = false;
        vm.addOpenSpot = addOpenSpot;
        vm.logo = setLogo;
        vm.isOver = isOver;
        vm.isTotal = isTotal;
        vm.isTeamTotal = isTeamTotal;
        vm.arrTickets = [];
        vm.Wait=0;
        vm.countdownWait = countdownWait;
        vm.setRRAmount = setRRAmount;
        vm.emptySelection = emptySelection;

        activate();

        ////////////////              

        function activate() {
            if (!is_bm) {
                notificationService.notify_showContinue(false);
                notificationService.notify_home_Button(0);
            }
            vm.selected = customerGameSelection.gameSelections.Items;
            vm.rr = customerGameSelection.gameSelections.RoundRobins;
            vm.pd = customerGameSelection.pitcherSelection;
            if (vm.selected.length == 0) { //if no selections display message
                //notificationService.showMessage('Please select one game.');
                if (!is_bm) {
                    if (appSettings.custWebCenterMenu)
                        $state.go('cog.default.customer-centermenu', { tp: accountService.getBetSelectionType(), sh: 0 });
                    else
                        $state.go('cog.default.customer-schedule', { tp: accountService.getBetSelectionType(), sport: customerGameSelection.sportSelections.UrlKey().toString() });
                } 
                else
                    $state.go('bm.default.leagues', { tp: accountService.getBetSelectionType() });
                vm.selected = customerGameSelection.gameSelections.Items;
            } 
            else {
                vm.selected = customerGameSelection.gameSelections.Items;
                vm.selCount = vm.selected.length;
                if (is_bm)
                    notificationService.notify_onBetConfirmView();
                calculateBets(0, null);
                setWinPush();
            }
            initOpenSpots();
        }

        function initOpenSpots() {
            if (!is_bm) { // for customer only
                if (_tp != BET_TYPES.S.type && _tp != BET_TYPES.E.type) {
                    vm.allowOpenSpotOption = customerGameSelection.openSpots.allowOpenSpots();
                    if (vm.allowOpenSpotOption)
                        checkOpenSpot();
                }
            }
        }

        function removeOpenSpot() {
            customerGameSelection.openSpots.removeOpenSpot();
            if (customerGameSelection.gameSelections.Items.length == 1 && customerGameSelection.openSpots.spots == 0) {
                if (!is_bm) {
                    if (appSettings.custWebCenterMenu) {
                        //$state.go('cog.default.customer-centermenu', { tp: accountService.getBetSelectionType(), sport: customerGameSelection.sportSelections.UrlKey().toString() });
                    } 
                    else {
                        customerGameSelection.gameSelections.Clear();
                        $state.go('cog.default.customer-schedule', { tp: accountService.getBetSelectionType(), sport: customerGameSelection.sportSelections.UrlKey().toString() });
                    }
                } 
                else {
                    customerGameSelection.gameSelections.Clear();
                    $state.go('bm.default.leagues', { tp: accountService.getBetSelectionType() });
                }
            } 
            else
                calculateBets(0, null);
            checkOpenSpot();
        }

        function showItemRiskWin(): boolean {
            var show: boolean = false;
            switch (_tp) {
                case BET_TYPES.S.type:
                case BET_TYPES.E.type:
                case BET_TYPES.I.type:
                    show = true;
                    break;
            } 
            return show;
        }

        $scope.range = function (n) {
            return new Array(n);
        };

        $scope.reCalculateBet = function () {
            calculateBets(0, null);
        }

        function setWinPush() {
            if (vm.isIfbet || vm.isActionReverse) {
                var wp: boolean = (vm.winpush == 0) ? false : true;
                customerGameSelection.gameSelections.SetWinPush(wp);
            }
        }

        function nexStepInnerLogic(result: BetCard){
            vm.sel = betModelTransformer.transform(result, false);

            var hasBetErrors = false;
            if (vm.sel.BetErrs.length>0) hasBetErrors = true; //this has a delay error or other.                

            if (parseInt(vm.sel.TicketNumber) < 0 && (is_bm || (!is_bm && !vm.isStraight) || hasBetErrors)) {
                calculateBets(0, vm.sel.BetErrs);
                vm.selectedIndex--;
            }
            else {
                vm.selectedIndex++;
                if (is_bm || (!is_bm && !vm.isStraight))
                    customerGameSelection.gameSelections.Clear();
                customerGameSelection.sportSelections.Clear();
                customerGameSelection.gameSelections.SetFreePlay(false);

                if (!is_bm)
                    notificationService.notify_onWagerTicket();
                else
                    notificationService.notify_onBMWagerTicket();

                vm.showFinalRR = false;
                jQuery.each(vm.sel.RoundRobinOptions, function (i, val) {
                    if (val.Risk > 0)
                        vm.showFinalRR = true;
                });                    

                if (!is_bm) {
                    if (vm.isStraight) {                            
                        var lineChanges = [];
                        var betDelete = [];
                        vm.betError = [];

                        jQuery.each(vm.sel.Details, function (i, val) {
                            if (parseInt(val.Error.Id) == 3 && !val.Error.AutoAccepted) {
                                lineChanges.push(angular.copy(val));
                                betDelete.push(i);
                            }
                            else {
                                if (parseInt(val.Error.Id) > 0 && (parseInt(val.Error.Id) != 3 && !val.Error.AutoAccepted)) {
                                    vm.betError.push(angular.copy(val));
                                    betDelete.push(i);
                                }
                                customerGameSelection.gameSelections.Remove(val.Id);
                            }
                        });                        

                        for (var i = betDelete.length - 1; i >= 0; i--)
                            vm.sel.Details.splice(betDelete[i], 1);

                        if(vm.sel.Details.length > 0)
                            vm.arrTickets.push(vm.sel);

                        if (lineChanges.length > 0) {
                            $mdDialog.show({
                                controller: 'BetAttDialogController',
                                controllerAs: 'vm',
                                templateUrl: 'app/core/customer/selstep1/bet-att-dialog.tmpl.html',
                                locals: {
                                    errList: lineChanges
                                },
                                fullscreen: false,
                                focusOnOpen: false,
                                escapeToClose: false
                            })
                            .then(function (response) {
                                if (response != null) {
                                    if (response.retry)
                                        nextStep(0);
                                    else {
                                        if (vm.sel.TicketNumber < 0 && vm.betError.length == 0) {
                                            if (appSettings.custWebCenterMenu)
                                                $state.go('cog.default.customer-centermenu', { tp: accountService.getBetSelectionType(), sh: 0 });
                                            else
                                                $state.go('cog.default.customer-schedule', { tp: accountService.getBetSelectionType(), sport: customerGameSelection.sportSelections.UrlKey().toString() });
                                        }
                                        customerGameSelection.gameSelections.Clear();
                                    }
                                }
                            });
                        }
                    }
                }
            }
        }

        function failSaveNoBetCard() {
            vm.apiError = true;
        }

        function checkConfirmStatus(result: BetCard, retryCount) {
            CogApiServiceProvider.apiCogService().confirmBet(result.TicketNumber)
            .then(function (resultConfirm) {
                if (resultConfirm.Status == 2) //Accepted
                    nexStepInnerLogic(result);
                else  
                    if (resultConfirm.Status == 3 || resultConfirm.Status == 4) //Error or NotFound
                        failSaveNoBetCard();
                    else
                        $timeout(function() { checkConfirmStatus(result, retryCount); }, 1000);
            }, 
            function(){
                if (retryCount <20)
                    $timeout(function() { checkConfirmStatus(result, ++retryCount); }, 1000);                
                else
                    failSaveNoBetCard();
            });                    
        }

        function postSelection(data, retryCount) {
            CogApiServiceProvider.apiCogService().postSelection(data)
            .then(function (result: BetCard) {
                if (result.TicketNumber > 0)
                    checkConfirmStatus(result,0);
                else 
                    nexStepInnerLogic(result); 
            },
            function() {
                if (retryCount < 10)
                    $timeout(function () { nextStep(++retryCount); }, 1000);
                else
                    failSaveNoBetCard();
            });
        }

        function countdownWait() {
            if (vm.Wait==0) return;
            local.WaitHandler = $timeout(function() {                
                vm.Wait--;                    
                countdownWait();
            }, 1000);
        }

        function nextStep(retryCount) {
            if (retryCount == 0)
                vm.selectedIndex++;
            customerGameSelection.gameSelections.SetFreePlay(vm.useFreePlay);
            var data = customerGameSelection.gameSelections.ToWager();
            data.DelayUntilSignature = local.DelayUntilSignature;
            data.DelayUntilUTC = local.DelayUntilUTC;
            data.CaptchaMessage = vm.captcha.CaptchaMessage;
            data.PasswordConfirmation = vm.confirmation.Password;

            //var dtDelay = new Date(data.DelayUntilUTC), dtNow = new Date();
            var wait = 0 // (dtDelay.getTime()- dtNow.getTime()) + 500; //pos val mean wait x seg, neg val we are ok to post bet.                        

            if (wait > 0){                 
                if (wait > 20*1000) wait = 20 * 1000;
                $timeout(function () {
                    postSelection(data, retryCount);    
                }, wait);
                vm.Wait=Math.ceil(wait/1000);
                vm.countdownWait();                
            }
            else 
                postSelection(data, retryCount);            
        }

        function cancelAll() {
            customerGameSelection.gameSelections.Clear();
            customerGameSelection.gameSelections.SetFreePlay(false);
            if (!is_bm) {
                _tp = BET_TYPES.S.type;
                notificationService.notify_goBetTypeSchedule(_tp, true);
            }
            checkOnCancelGame();
        }

        function cancel(idSelection) {
            customerGameSelection.gameSelections.Remove(idSelection);
            //var _tp = accountService.getBetSelectionType();
            if (_tp != BET_TYPES.S.type && _tp != BET_TYPES.E.type) {
                customerGameSelection.gameSelections.ClearRR();
                //var _gmsSelected = customerGameSelection.gameSelections.Items.length + customerGameSelection.openSpots.spots;
                var _gmsSelected = customerGameSelection.gameSelections.Items.length;
                var minTeams: number = 2;
                if (_tp === BET_TYPES.T.type)
                    minTeams = customerGameSelection.teaserLimits.minProfileTeams();
                var allowOpenSpots = customerGameSelection.openSpots.allowOpenSpots();
                if (allowOpenSpots)
                    minTeams = 1;
                if (_gmsSelected >= minTeams)
                    calculateBets(0, null);
                else
                    customerGameSelection.gameSelections.Clear();
            }
            else
                if (customerGameSelection.gameSelections.Items.length > 0)
                    calculateBets(0, null);
            checkOnCancelGame();
        }

        function checkOnCancelGame() {
            //var _tp = accountService.getBetSelectionType();
            //var _gmsSelected = customerGameSelection.gameSelections.Items.length + customerGameSelection.openSpots.spots;
            var _gmsSelected = customerGameSelection.gameSelections.Items.length;
            var routeState: String = (!is_bm) ? (appSettings.custWebCenterMenu ? 'cog.default.customer-centermenu' : 'cog.default.customer-schedule') : 'bm.default.leagues';
            var routParams: any = { tp: _tp, sh: 0 };
            if (_tp == BET_TYPES.S.type || _tp == BET_TYPES.E.type) {
                if (_gmsSelected == 0)
                    $state.go(routeState, routParams);
            } 
            else {
                //if (_gmsSelected < 2) {
                if (_gmsSelected < 2 && customerGameSelection.openSpots.spots == 0) {
                    if (_tp == BET_TYPES.T.type) {
                        if (!is_bm)
                            routParams = { tp: _tp, tid: customerGameSelection.sportSelections.UrlKey() };
                        $state.go(routeState, routParams);
                    } 
                    else
                        $state.go(routeState, routParams);
                    if (_gmsSelected > 0) {
                        $mdToast.show({
                            template: '<md-toast><span flex>It requires at least 2 game selection to continue</span></md-toast>',
                            position: 'bottom right',
                            hideDelay: 3000
                        });
                    }
                }
            }
            checkOpenSpot();
        }

        function acceptLine(PreviousId, NewLineId, Replace) {
            customerGameSelection.gameSelections.Swap(PreviousId, NewLineId, Replace);
            calculateBets(0, null);
        }

        function calculateBets(retryCount, betErrors) {
            customerGameSelection.gameSelections.SetFreePlay(vm.useFreePlay);
            var dataContainer = customerGameSelection.gameSelections.ToWager();
            var data = dataContainer==null? null : dataContainer.Details;

            vm.arrTickets = [];
            vm.betError = [];
            vm.captcha = { CaptchaImage: null, CaptchaMessage: "", Error: false, Description: "" };
            vm.confirmation = { NeedConfirmation: false, Password: "", Error: false, Description: "" };

            if (data != null && data.length > 0) {
                vm.loader = true;
                //cogApiService.createSelection(data).then(function (result: BetCard) {
                CogApiServiceProvider.apiCogService().createSelection(data)
                .then(function (result: BetCard) {
                    vm.loader = false;
                    vm.sel = betModelTransformer.transform(result, true);
                    local.DelayUntilSignature = result.DelayUntilSignature;
                    local.DelayUntilUTC = result.DelayUntilUTC;
                    vm.EnabledFreePlay = result.AllowFreePlay;
                    if(result.CaptchaImage != null) {
                        vm.captcha.CaptchaImage = result.CaptchaImage;
                        vm.captcha.CaptchaMessage = result.CaptchaMessage;
                        var errIndex = -1;
                        jQuery.each(betErrors, function (i, val) {
                            if(val.Description.toLowerCase().indexOf("captcha")>-1)
                                errIndex = i;
                        });
                        if(errIndex>-1) {                            
                            vm.captcha.Error = true;
                            vm.captcha.Description = betErrors[errIndex].Description;
                            betErrors = [];
                        }
                    }
                    if(result.NeedConfirmation)  {
                        vm.confirmation.NeedConfirmation = true;
                        var errIndex = -1;
                        jQuery.each(betErrors, function (i, val) {
                            if(val.Description.toLowerCase().indexOf("password")>-1)
                                errIndex = i;
                        });
                        if(errIndex>-1) {
                            vm.confirmation.Error = true;
                            vm.confirmation.Description = betErrors[errIndex].Description;
                            betErrors = [];
                            $mdDialog.show({
                                clickOutsideToClose: false,     
                                scope: $scope,
                                preserveScope: true,
                      
                                template: 
                                        '<md-dialog>' +
                                        '   <md-dialog-content class="md-dialog-content text-center font-weight-600" style="color:#bf4040">' + vm.confirmation.Description + '</md-dialog-content>' +
                                        '   <md-dialog-actions>' +
                                        '       <md-button ng-click="closeDialog()" class="md-raised" flex="90">' +
                                        '           Try Again' +
                                        '       </md-button>' +
                                        '   </md-dialog-actions>' +
                                        '</md-dialog>',
                      
                                controller: function DialogController($scope, $mdDialog) {
                                    $scope.closeDialog = function() {
                                        $mdDialog.hide();
                                        angular.element(document.getElementById('password')).focus();
                                    }
                                }
                             });
                        }
                    }

                    if (betErrors!=null) {
                        if (vm.sel.BetErrs==null) vm.sel.BetErrs = [];
                        jQuery.each(betErrors, function (i, val) {
                            vm.sel.BetErrs.push(betErrors[i]);
                        });
                    }

                    jQuery.each(vm.sel.RoundRobinOptions, function (i, val) {
                        var rr: RoundRobinSel = { Teams: val.Teams, Amount: 0 };
                        customerGameSelection.gameSelections.AddRR(rr);
                    });

                    var hasError = false;
                    var formated: FormatedLine = null;
                    var format: string = "";
                    var override: boolean = true;
                    var betDelete = [];
                    jQuery.each(vm.sel.Details, function (i, val) {
                        if (parseInt(val.Error.Id) > 0 && !val.Error.AutoAccepted) {
                            if (val.Error.CancelOnError)
                                override = false;
                            if (vm.isStraight && (parseInt(val.Error.Id) != 3) && val.Error.Description == 'Game is not available' && !is_bm) {
                                vm.betError.push(angular.copy(val));
                                betDelete.push(i);
                                customerGameSelection.gameSelections.Remove(val.Id);
                            }
                            else
                                hasError = true;
                        }

                        // update risk/win
                        if (is_bm && lineDataEdited) {
                            customerGameSelection.gameSelections.RiskChange(val.Id, val.Risk);
                            customerGameSelection.gameSelections.WinChange(val.Id, val.Win);
                            var tempId = val.Id;
                            var arrKey = tempId.split('_');
                            arrKey[2] = val.Points;
                            arrKey[3] = val.Odds;
                            tempId = arrKey.join('_');
                            formated = lineFormater.format(tempId);
                            if (formated.Points.length > 0)
                                format = formated.Points + "&nbsp;<span class='txt2'>" + formated.Odds + "</span>";
                            else
                                format = formated.Odds;
                            customerGameSelection.gameSelections.PointsTxtChange(val.Id, format);
                        }
                    });
                    lineDataEdited = false; // reset to false for unnecessary values change

                    if(!is_bm) {
                        for (var i = betDelete.length - 1; i >= 0; i--)
                            vm.sel.Details.splice(betDelete[i], 1);
                    }

                    // check Bet errs                    
                    if (vm.sel.BetErrs.length > 0) {
                        hasError = true;
                        jQuery.each(vm.sel.BetErrs, function (i, val) {
                            if (val.ErrorType)
                                override = false;
                        });
                    }                    

                    vm.hasError = hasError;
                    vm.allowOverRide = override;
                    if (is_bm) {
                        //$rootScope.$emit('MSG_BM_BET_EVENT');
                        if (!hasError)
                            notificationService.notify_MSG_BM_BET_EVENT();
                    }
                    if (!hasError)
                        checkDisplayConfirm(dataContainer);
                }, 
                function () {
                    if (retryCount < 10)
                        $timeout(function () { calculateBets(++retryCount, betErrors); }, 1000);
                    else
                        failSaveNoBetCard();
                });
            }
        }

        function checkDisplayConfirm(data) {
            vm.noWagerBet = false;
            // for customer & P,T & AR check if there is any bet placed to set vm.hasError and disable continue button
            if (!vm.showItemRiskWin) {
                if (data.Details[0].Amount == 0) {
                    if (data.Details[0].RoundRobinOptions != null && data.Details[0].RoundRobinOptions.length > 0) {
                        var fnd = $window._.findIndex(data.Details[0].RoundRobinOptions, function (rr) {
                            return (rr.Amount > 0);
                        })
                        if (fnd == -1)
                            vm.noWagerBet = true;
                    }
                    else
                        vm.noWagerBet = true;
                }
            }
        }

        vm.$onDestroy = function () {
            $mdDialog.cancel();
            if (local.WaitHandler != null)  $timeout.cancel(local.WaitHandler);
        };

        function changeAmount(itmId: string, riskAmount: number, amtType: string) {
            $mdDialog.show({
                controller: 'AmountChangeDialogController',
                controllerAs: 'vm',
                templateUrl: appSettings.sharedPath + 'customer/selstep1/amount-change-dialog.tmpl.html',
                locals: {
                    amount: riskAmount,
                    itmId: itmId,
                    numTeams: 0,
                    freePlay: (vm.isStraight || vm.isIfbet) ? 0 : vm.FreePlayBalance,
                    usefreePlay: vm.useFreePlay,
                    amtType: amtType
                },
                fullscreen: false,
                focusOnOpen: false
            })
            .then(function (response) {
                if (response != null) {
                    if (vm.isStraight || vm.isIfbet) {
                        customerGameSelection.gameSelections.AmountChange(response.Id, response.Amount, amtType);
                    } 
                    else {
                        // parlay | teaser | AR
                        vm.betAmount = response.Amount;
                        customerGameSelection.gameSelections.SetBetAmount(response.Amount);
                    }
                    lineDataEdited = true;
                    vm.useFreePlay = response.UseFreePlay;
                    customerGameSelection.gameSelections.SetFreePlay(vm.useFreePlay);
                    calculateBets(0, null);
                }
            });
        }

        function editDetails(itmId: string, teamName: string, amt: number, isStraightorIfbet: boolean, Points: number, Odds: number) {
            $mdDialog.show({
                controller: 'BMEditDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/bm/components/selstep1/bm-edit-dialog.tmpl.html',
                locals: {
                    itmId: itmId,
                    teamName: teamName,
                    amount: amt,
                    isStraightorIfbet: isStraightorIfbet,
                    points: Points,
                    odds: Odds
                },
                fullscreen: false,
                focusOnOpen: false
            })
            .then(function (response) {
                if (response != null) {
                    if (vm.isStraight || vm.isIfbet)
                        customerGameSelection.gameSelections.AmountChange(response.Id, response.Amount,'A');
                    customerGameSelection.gameSelections.Swap(response.Id, response.NewId, false);
                    lineDataEdited = true;
                    calculateBets(0, null);
                }
            });
        }

        function betNumLbl() {
            return (customerGameSelection.gameSelections.Items.length + customerGameSelection.openSpots.spots) + " team " + accountService.getBetSelectionDesc();
        }

        // get label for ticket
        function ticketNumLbl() {
            //console.log(vm.sel);
            return (vm.sel.Details.length + vm.sel.OpenSpots) + " team " + accountService.getBetSelectionDesc();
        }

        function chgAmtRR(numTeams: number, numCombinations: number, amount: number) {
            $mdDialog.show({
                controller: 'AmountChangeDialogController',
                controllerAs: 'vm',
                templateUrl: appSettings.sharedPath + 'customer/selstep1/amount-change-dialog.tmpl.html',
                locals: {
                    amount: (amount / numCombinations),
                    itmId: 0,
                    numTeams: numTeams,
                    freePlay: 0,
                    usefreePlay: false,
                    amtType: 'A'
                },
                fullscreen: false,
                focusOnOpen: false
            })
            .then(function (response) {
                if (response != null) {
                    var rr: RoundRobinSel = { Teams: numTeams, Amount: response.Amount };
                    customerGameSelection.gameSelections.ChangeAmtRR(rr);
                    calculateBets(0, null);
                }
            });
        }

        function cancelRR(numTeams: number) {
            if (numTeams > 0) {
                var rr: RoundRobinSel = { Teams: numTeams, Amount: 0 };
                customerGameSelection.gameSelections.ChangeAmtRR(rr);
                calculateBets(0, null);
            }
        }

        function cancelMain() {
            vm.betAmount = 0;
            customerGameSelection.gameSelections.SetBetAmount(0);
            calculateBets(0, null);
        }

        function overrideRules() {
            $mdDialog.show(
                $mdDialog.confirm()
                    .title("Confirm Override")
                    .textContent("Please confirm you want to override rules on this play.")
                    .ok("Confirm")
                    .cancel("Cancel")
            )
            .then(function () {
                nextStep(0);
            });
        }

        function totalRR() {
            var totalRRRisk = 0;
            var totalRRWin = 0;
            angular.forEach(vm.sel.RoundRobinOptions, function (value, key) {
                totalRRRisk += value.Risk;
                totalRRWin += value.Win;
            });

            totalRRRisk += vm.sel.Details[0].Risk;
            totalRRWin += vm.sel.Details[0].Win;

            return { totalRisk: totalRRRisk, totalWin: totalRRWin }
        }

        function gotoPending() {
            var strPending = "cog.default.customer-pendingcat";
            if (accountService.getPendingTemplate())
                strPending = "cog.default.customer-pending";
            $state.go(strPending);
        }

        function setLogo(id, league, logo) {
            var formated = lineFormater.data(id);
            var logoLeague = (league != null && angular.isNumber(league) && league > 0) ? ("lg" + league.toString()) : "";
            var logoTeam = (logo != null && angular.isNumber(logo) && logo > 0) ? ("l" + logo.toString()) : "";
            if (formated.IsTotal)
                return "";
            else
                return (logoLeague != "" && logoTeam != "") ? (logoLeague + " " + logoTeam) : "";
        }

        function isTotal(id) {
            var formated = lineFormater.data(id);
            return formated.IsTotal;
        }

        function isTeamTotal(id) {
            var formated = lineFormater.data(id);
            return formated.IsTeamTotal;
        }

        function isOver(id) {
            var formated = lineFormater.data(id);
            if (formated.Type == 'TO')
                return true;
            return false;
        }

        function setRRAmount() {
            var arrAmt = 0;
            if (vm.expandRR)
                arrAmt = customerGameSelection.gameSelections.GetBetAmount()
            angular.forEach(vm.sel.RoundRobinOptions, function (value, key) {
                var rr: RoundRobinSel = { Teams: value.Teams, Amount: arrAmt };
                customerGameSelection.gameSelections.ChangeAmtRR(rr);
            });
            calculateBets(0, null);
        }

        var keyup = function(e) {
            var curState = $state.current.name;
            if(e.keyCode == 13 && curState == 'cog.default.customer-selstep1' && angular.element(document).find('md-dialog').length == 0 && (vm.arrTickets.length > 0 || (vm.sel.TicketNumber > 0 && !vm.isStraight)))
                gotoPending();
        };

        angular.element(window).on('keyup', keyup);

        $scope.$on('$destroy', function(){
            angular.element(window).off('keyup', keyup);
        });

        /* ---------------------------- for selstep1cust ---------------------------------*/
        function selectAllContent($event) {
            $event.target.select();
        }

        function placeBetAmount() {
            if (vm.betAmount >= 0) {
                customerGameSelection.gameSelections.SetBetAmount(vm.betAmount);
                lineDataEdited = true;
                calculateBets(0, null);
            }
        }

        function onBuyPointsChange(item: BetDetailSimple) {
            var curItmId: string = item.Id;
            var newItmId: string = item.lineSelected.Id;
            acceptLine(curItmId, newItmId, false);
        }

        /////////////// OPEN SPOTS /////////////////

        function checkOpenSpot() {
            if (!is_bm) { // for customer only
                if (vm.expandRR) {
                    vm.expandRR = !vm.expandRR;
                    jQuery.each(customerGameSelection.gameSelections.RoundRobins, function (i, val) {
                        val.Amount = 0;
                    });
                }
                vm.allowOpenSpotOption = customerGameSelection.openSpots.allowOpenSpots();
                vm.sel.OpenSpots = customerGameSelection.openSpots.getOpenSpots();
                if (vm.allowOpenSpotOption) {
                    var legs: number = customerGameSelection.gameSelections.Items.length;
                    legs += vm.sel.OpenSpots;
                    if (vm.sel != null && vm.sel.Details != null)
                        ticketNumLbl();
                    if (legs >= 2)
                        vm.hasError = false;
                    else {
                        if (vm.sel != null && vm.sel.Details != null)
                            vm.hasError = true;
                    }
                    if (!vm.hasError) {
                        var data = customerGameSelection.gameSelections.ToWager();
                        if (data != null)
                            checkDisplayConfirm(data);
                    }
                }
            }
        }

        function addOpenSpot() {
            if (vm.allowOpenSpotOption) {
                customerGameSelection.openSpots.addOpenSpot();
                calculateBets(0, null);
            }
            checkOpenSpot();
        }

        /////////////// OPEN SPOTS /////////////////

        function getFormatLine(id) {
            var formated = lineFormater.format(id);
            var format:string = "";
            if (formated.Points.length > 0)
                format = formated.Points + "&nbsp;<span class='txt2'>" + formated.Odds + "</span>";
            else
                format = formated.Odds;
            return format;
        }

        function onInputEnter(ev) {
            if (ev.keyCode == '13')
                nextStep(0);
        }

        function emptySelection(){
            return angular.equals({}, vm.sel);
        }

        /* ---------------------------- for selstep1cust ---------------------------------*/
    }
})();